import React, { memo } from 'react'
import MaskedInput from 'react-text-mask'
import PropTypes from 'prop-types'

const Input = memo(({
  name, value, mask, onChange, onResetNumber, placeholder,
  showButtonDelete, setRef, autoFocus, title, className, maxLength, type,
  marker, textValid = '', pattern, disabled, typeMask, onBlur }) => {

  return (
    <div className={`input-root-container ${className} ${textValid && textValid.length !== 0 && 'error-validation'}
    ${disabled && 'disabled'}
    `}>
      <span className="title-text">{title || ''}</span>
      <div className="input-container">
        {mask ?
          <MaskedInput
            name={name || "input"}
            value={value && value}
            onChange={onChange}
            guide={false}
            mask={mask}
            autoFocus={autoFocus}
            placeholder={placeholder || ''}
            ref={setRef}
            maxLength={maxLength}
            pattern={pattern}
            disabled={disabled || false}
            type={typeMask}
            onBlur={onBlur}
          />
          :
          <input
            name={name || "input"}
            value={value && value}
            onChange={onChange}
            guide='false'
            autoFocus={autoFocus}
            placeholder={placeholder || ''}
            ref={setRef}
            maxLength={maxLength}
            type={type || 'text'}
            pattern={pattern}
            disabled={disabled || false}
            onBlur={onBlur}
          />
        }
        {showButtonDelete &&
          <button type='button' className="button-reset-value" onClick={onResetNumber && onResetNumber} />
        }
        {marker && <span className='input-marker'>{marker}</span>}
        {textValid && textValid.length !== 0 && <span className={`input-error-valid`}>{textValid}</span>}
      </div>
    </div>
  )
})

Input.displayName = 'Input'

Input.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  mask: PropTypes.array,
  onChange: PropTypes.func,
  onResetNumber: PropTypes.func,
  placeholder: PropTypes.string,
  showButtonDelete: PropTypes.bool,
  setRef: PropTypes.object,
  autoFocus: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  type: PropTypes.string,
  marker: PropTypes.string,
  textValid: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  pattern: PropTypes.string,
  disabled: PropTypes.bool
}

export default Input